<template>
  <div class="fts-toggle-button">
    <template v-if="options && options.length">
      <div 
        class="toggle-button" 
        :class="{'toggle-button-active': isSelected(option)}"
        v-for="option in options" 
        :key="option.id"
        @click="select(option)" >
        {{getLabel(option)}}
      </div>
    </template>

    <div class="toggle-button-no-found" v-else>No options found</div>
  </div>
</template>

<script>
export default {
  props: {
    formData: Object,
    item: Object,
    options: {
      type: Array,
      default: () => []
    },  
    label: {
      type: String,
      default: "name"
    },
    reduce: {
      type: Function,
      default: x => x
    },
    multiple: Boolean
  },
  methods: {
    isObject(option) {
      if (option && typeof option === 'object' && !Array.isArray(option))
        return true
    },

    getLabel(option) {
      if (this.label && option && this.isObject(option)) {
        if (option[this.label] === undefined) 
          console.warn(`FTSToggleButton ${this.label} does not exist`)
        
        return option[this.label]
      }

      return option
    },
    select(option) {
      let res = option
      if (typeof(this.reduce) === 'function' && this.isObject(option)) 
        res = this.reduce(option)
      
      if (this.multiple) {
        if (!this.formData[this.item.fieldName] || this.formData[this.item.fieldName] && (!this.formData[this.item.fieldName].length))
          this.$set(this.formData, this.item.fieldName, [])
    
        if (this.isSelected(res)) 
          this.formData[this.item.fieldName].splice(this.formData[this.item.fieldName].indexOf(res), 1)
        else
          this.formData[this.item.fieldName].push(res)

      } else {
        this.$set(this.formData, this.item.fieldName, res)
      }

      this.$emit('select', res)
    },
    isSelected(option) {
      let res = option
      if (typeof(this.reduce) === 'function' && this.isObject(option)) 
        res = this.reduce(option)

      if (this.multiple) {
        if (Array.isArray(this.formData[this.item.fieldName]) && this.formData[this.item.fieldName])
          return this.formData[this.item.fieldName].find(x => x === res)
      } else {
        return this.formData[this.item.fieldName] === res
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-toggle-button {
  display: inline-flex;
  border: 1px solid var(--fts-gray-3);
  background: #fff;
  .toggle-button {
    @include flex-center-middle;
    @include user-select-none;
    position: relative;
    flex-grow: 1;
    padding: .375rem 1rem;    
    font-size: .75rem;
    line-height: 1.5;
    color: $primaryColor;
    text-transform: capitalize;
    transition: all .15s ease-in-out;
    &:hover, &.toggle-button-active {  
      cursor: pointer;
      &::after {
        border-color: transparent !important;
      }
    }
    &:hover {
      @include theme() {
        background-color: rgba(theme-get('fts-gray-4'), .5);
      }
    }
    &.toggle-button-active {
      // box-shadow: $btnBoxShadowHover;
      background: $primaryColor;
      color: #fff;
    }
    &:not(:first-child)::after {
      content: "";
      position: absolute;
      left: 0;
      top: .375rem;
      bottom: .375rem;
      border-left: 1px solid var(--fts-gray-3);
    }
  }
  .toggle-button:hover + .toggle-button::after, 
  .toggle-button-active + .toggle-button::after {
    border-color: transparent;
  }
  .toggle-button-no-found {
    font-size: .75rem;
    padding: .375rem 1rem;
    line-height: 1rem;
    font-style: italic;
    color: var(--fts-gray-5);
  }
}
</style>